const Appdispute = () =>
    import('@/module/index/layout/Appdispute.vue')
const trainingMaterial = () =>
    import('@/module/index/pages/trainingMaterial/trainingMaterial.vue')
const userTrainingMaterial = () =>
    import('@/module/index/pages/trainingMaterial/userTrainingMaterial.vue')
export default {
  path: '/',
  component: Appdispute,
  meta: {
    title: ''
  },
  children: [{
    path: '/trainingMaterial', // 工作人员培训材料
    name: 'trainingMaterial',
    component: trainingMaterial
  }, {
    path: '/userTrainingMaterial', // 用户端信访代理人培训材料
    name: 'userTrainingMaterial',
    component: userTrainingMaterial
  }]

}



// WEBPACK FOOTER //
// ./src/publicResource/router/trainingMaterial.js